"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SimpleOffer {
    constructor(id, dataLayer, displayName, equipments, facebookAutomotiveData, topEquipmentLabels, image, isAvailableSooner, mileageYearly, offerLabelList, order, powertrain, priceOfferList, colors, trim, hasWinterTires) {
        this.id = id;
        this.dataLayer = dataLayer;
        this.displayName = displayName;
        this.equipments = equipments;
        this.facebookAutomotiveData = facebookAutomotiveData;
        this.topEquipmentLabels = topEquipmentLabels;
        this.image = image;
        this.isAvailableSooner = isAvailableSooner;
        this.mileageYearly = mileageYearly;
        this.offerLabelList = offerLabelList;
        this.order = order;
        this.powertrain = powertrain;
        this.priceOfferList = priceOfferList;
        this.colors = colors;
        this.trim = trim;
        this.hasWinterTires = hasWinterTires;
    }
}
exports.default = SimpleOffer;
